var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinersColored = function SvgDinersColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.717 19.845c4.33.02 8.283-3.532 8.283-7.854C22 7.265 18.047 3.998 13.717 4H9.99C5.607 3.998 2 7.266 2 11.991c0 4.323 3.607 7.875 7.99 7.854h3.727Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.006 4.655a7.253 7.253 0 0 0 0 14.506 7.253 7.253 0 0 0 0-14.506ZM5.41 11.908a4.605 4.605 0 0 1 2.951-4.29v8.58a4.603 4.603 0 0 1-2.95-4.29Zm6.241 4.292V7.618a4.602 4.602 0 0 1 2.953 4.29A4.603 4.603 0 0 1 11.65 16.2Z",
    fill: "#fff"
  })));
};
export default SvgDinersColored;